import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import * as actions from "../../actions";
import "react-phone-input-2/lib/style.css";
import "antd/dist/antd.css";
import ShipperBasicForm from "./ShipperBasicForm";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { labelStyle, radioStyle } from "./styles";
import { isEmpty } from "../../util/isEmpty";
// import Select from "react-select";

import {
  Form,
  Input,
  Radio,
  Row,
  Col,
  Typography,
} from "antd";
import DutyAndTax from "./DutyAndTax";
import CargoInsurance from "./CargoInsurance";

const { Title } = Typography;

class ShipperReceiverForm extends React.Component {
  state = {
    showCustomBrokerInput: false,
  };

  handleCustomBrokerChange = (e) => {
    const showInput = e.target.value === "custom"; // '1' represents the value of the option "I have my own customs broker"
    this.setState({ showCustomBrokerInput: showInput });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { initialFormData } = this.props; // Access initialFormData from props
    return (
      <div>
        <ShipperBasicForm
          {...{ form: this.props.form }}
          initialFormData={initialFormData}
        />

        <Row>
          <Title
            level={2}
            style={{ paddingBottom: "1rem", borderBottom: "2px solid black" }}
          >
            Your Customs Broker
          </Title>
          <Form.Item label={<span style={labelStyle}>Customs Broker</span>}>
            {getFieldDecorator("custom_broker", {
              initialValue: initialFormData.custom_broker,
              rules: [
                {
                  required: true,
                  message: "Please input customs broker",
                },
              ],
            })(
              <Radio.Group
                name="custom_broker"
                onChange={this.handleCustomBrokerChange}
              >
                <Radio style={radioStyle} value={"primeFreight"}>
                  Let Prime Freight Nominate the Broker (+$75)
                </Radio>
                <Radio
                  style={{ ...radioStyle, paddingTop: "10px" }}
                  value={"custom"}
                >
                  I have my own customs broker
                </Radio>
              </Radio.Group>
            )}

            {this.state.showCustomBrokerInput && (
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  label={<span style={labelStyle}>Customs Broker Name</span>}
                >
                  {getFieldDecorator("custom_broker_name", {
                    initialValue: initialFormData.custom_broker_name,
                    rules: [
                      {
                        required: true,
                        message: "Please input customs broker name",
                      },
                    ],
                  })(
                    <Input
                      size="large"
                      placeholder="Customs Broker Name"
                      style={{ width: "100%" }}
                    />
                  )}
                </Form.Item>
              </Col>
            )}
          </Form.Item>
        </Row>

        <div>
          <Title
            level={2}
            style={{ paddingBottom: "1rem", borderBottom: "2px solid black" }}
          >
            Cargo Insurance
          </Title>

          <CargoInsurance
            //{...{ form: this.props.form }}
            form={this.props.form}
            commodityArr={this.props.commodityArr}
            insuranceArr={this.props.insuranceArr}
            queryParams={this.props.queryParams}
            final_search_form={this.props.final_search_form}
            jwt_token={this.props.jwt_token}
            onInsuranceAmountChange={this.props.handleInsuranceAmountChange}
            onCommodityChange={this.props.handleCommodityChange}
            onAddCommodity={this.props.handleAddCommodity}
            onDeleteCommodity={this.props.handleDeleteCommodity}
          />
        </div>
 
        {this?.props?.insuranceArr && this.props?.insuranceArr.length > 0 && (
            <div style={{paddingTop:"1rem"}}>
              {this.props?.insuranceArr?.map((item, index) => {
                // Check if item is not empty (assuming isEmpty is a valid function)
                if (!isEmpty(item)) {
                  const commodityCategory = item?.commodity_category_type;
                  const description = item?.commodity_description;
                  const premiumAmount = item?.quote?.premium_amount !== null
                    ? item?.quote?.premium_amount
                    : "-";

                  return (
                    <div key={index}
                    >
                      <p style={{ paddingTop: "1rem" }}>
                        <b style={{ fontWeight: "bold" }}>{description} : </b> {`$ ${premiumAmount || 0}`}
                      </p>
                    </div>
                  );
                }
                // Return null if item is empty (or no valid item)
                return null;
              })}
              <p style={{ padding: "1rem 0" }}>
                {" "}
                <b style={{fontWeight:"bold"}}>Total Insurance : </b>{" "}
                {`$ ${
                  this.props?.insuranceArr?.reduce((sum, item) => {
                    return sum + Number(item?.quote?.premium_amount);
                  }, 0) || 0
                }`}{" "}
              </p>
            </div>
        )}

        <div style={{paddingTop:"2rem"}}>
        <Title
          level={2}
          style={{ paddingBottom: "1rem", borderBottom: "2px solid black" }}
        >
          Duty and Tax
        </Title>

        <DutyAndTax
          {...{ form: this.props.form }}
          dutyTax={this.props.dutyTax}
          dutyTax_amount_subtotal={this.props.dutyTax_amount_subtotal}
          onDutyTaxChange={this.props.handleDutyTaxChange}
          onAddDutyTax={this.props.handleAddDutyTax}
          onDeleteDutyTax={this.props.handleDeleteDutyTax}
          onDutyTaxAmountSubtotalChange={
            this.props.handleDutyTaxAmountSubtotalChange
          }
          queryParams={this.props.queryParams}
          final_search_form={this.props.final_search_form}
          jwt_token={this.props.jwt_token}
        />
        </div>
        <div style={{ padding: "1rem 0" }}>
          <p style={{ paddingTop: "1rem" }}>
            {" "}
            <b> Duty : $ </b> {this.props.dutyTax_amount_subtotal.duties}{" "}
          </p>
          <p style={{ paddingTop: "1rem" }}>
            {" "}
            <b> Taxes : $ </b> {this.props.dutyTax_amount_subtotal.taxes}{" "}
          </p>
        </div>

        <div
          style={{
            borderBottom: "1px solid #e8e8e8",
            paddingBottom: "1rem",
            marginBottom: "1rem",
          }}
        ></div>
      </div>
    );
  }
}

const WrappedShipperReceiverForm = Form.create({ name: "shipperReceiver" })(
  ShipperReceiverForm
);

ShipperReceiverForm.propTypes = {
  /**
   * array index (starts from zero) of selected pickup/delivery existing factory in the list of factories.
   * It also accepts `null`
   */
  final_search_form: PropTypes.object,
};
const mapStateToProps = (state) => {
  //console.log("state: ",state.code_config, state.route.final_search_form)
  return {
    queryParams: state.route.queryParams,
    final_search_form: state.route.final_search_form,
    jwt_token: state.route.JWT_TOKEN.JWT_TOKEN,
  };
};

export default withRouter(
  connect(mapStateToProps, actions)(WrappedShipperReceiverForm)
);
